"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[716],{

/***/ 7673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8193);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utilities_requestsTypes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2807);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1444);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(993);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_8__);












function Home(props) {
    var ref = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_5__.useSession)(), data = ref.data, status = ref.status;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), hide = ref1[0], setHide = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), helpHide = ref2[0], setHelpHide = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref3[0], setOpen = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), search = ref4[0], setSearch = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        user: null,
        token: null
    }), usr = ref5[0], setUsr = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        data: {
            fullName: "",
            profilePicUrl: "/images/profilepic_avatar.png"
        }
    }), userProfile = ref6[0], setUserProfile = ref6[1];
    // useEffect(() => {
    //   getProfile();
    //   console.log(loginState);
    // }, []);
    // const u = getAuth(app);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (status === "authenticated") {
            if (!data.user.fullyRegistered) {
                router.push("/nameandphone");
            }
            if (!data.user.emailVerified) {
                router.push("/verifyemail");
            }
            getProfile();
        }
    }, [
        status
    ]);
    var getProfile = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var u, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _utilities_requestsTypes__WEBPACK_IMPORTED_MODULE_6__/* .toBackend.get */ .v.get("user/profile", {
                                headers: {
                                    accesstoken: data.user.token
                                }
                            })
                        ];
                    case 1:
                        u = _state.sent();
                        setUserProfile(u.data);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getProfile() {
            return _ref.apply(this, arguments);
        };
    }();
    // const logOut = async () => {
    //   signOut(u).then(() => {
    //     Cookies.remove("user");
    //     localStorage.removeItem("authtoken");
    //   location.reload();
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // }
    var showSearchResult = function() {
        router.push("/searchresult/" + search);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex px-6 gap-4 xl:gap-10 relative items-center justify-between py-2 h-[70px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "block md:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "/images/logo.png",
                                layout: "fixed",
                                alt: "none",
                                className: "hover:cursor-pointer",
                                width: 80,
                                height: 40
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden md:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "/images/logo.png",
                                layout: "fixed",
                                alt: "none",
                                className: "hover:cursor-pointer",
                                width: 110,
                                height: 50
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                className: "w-full lg:flex lg:items-center lg:w-auto z-100 ".concat(open ? "flex flex-row bg-primary" : "block xl:block"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center absolute top-4 left-[50%] z-50 translate-x-[-50%] w-fit hidden md:block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "xl:w-[600px] md:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative flex w-full rounded",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative outline-none flex block w-full items-center text-base font-normal bg-gray-200 text-gray-700 bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-gray-100 justify-between",
                                    onClick: function() {
                                        router.push("/searchresult");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "ml-4",
                                            children: "Search for product, category"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "px-4 ml-[-10px] flex z-10 py-2.5 bg-yellow text-primary font-medium text-xs leading-tight uppercase rounded-r-md hover:text-white hover:shadow-lg focus:bg-blue-700 focus:shadow-lg outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                "aria-hidden": "true",
                                                focusable: "false",
                                                "data-prefix": "fas",
                                                "data-icon": "search",
                                                className: "w-4",
                                                role: "img",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 512 512",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    fill: "currentColor",
                                                    d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(status == "loading" ? "flex" : "hidden", " justify-center items-center"),
                        children: "Loading..."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(status == "unauthenticated" ? "flex" : "hidden", "  justify-end w-full gap-2 xl:gap-6"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpButton, {
                                        hide: helpHide,
                                        setHide: setHelpHide
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "",
                                onClick: function() {
                                    router.push("/login");
                                },
                                children: "Login"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "flex flex-nowrap items-center justify-center w-[80px] p-1 rounded-[20px] bg-primary text-white",
                                onClick: function() {
                                    router.push("/signup");
                                },
                                children: "Sign Up"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(status == "authenticated" ? "flex" : "hidden", "  justify-end w-full gap-2 xl:gap-6"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center gap-x-2 text-bold text-xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_11__/* .AiOutlineShoppingCart */ .nxQ, {
                                        className: "text-[25px]"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "dropdown relative bg-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            className: " dropdown-toggle px-2 py-2.5 transition duration-150 ease-in-out flex relative items-center whitespace-nowrap ",
                                            type: "button",
                                            id: "dropdownMenuButton1",
                                            onClick: function() {
                                                setHide(!hide);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    src: data ? data.user.image : "",
                                                    className: "rounded-full",
                                                    layout: "fixed",
                                                    width: 25,
                                                    height: 25
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    "data-prefix": "fas",
                                                    "data-icon": "caret-down",
                                                    className: "w-2 ml-2",
                                                    role: "img",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        fill: "currentColor",
                                                        d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: "\n          dropdown-menu\n          absolute\n          min-w-max\n          block\n          bg-white\n          text-base\n          ".concat(hide == true ? "hidden" : "block", "\n          z-[200]\n          float-left\n          py-2\n          right-0\n          list-none\n          text-left\n          rounded-lg\n          shadow-lg\n          mt-1\n          m-0\n          bg-clip-padding\n          border-none\n        "),
                                            "aria-labelledby": "dropdownMenuButton1",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: " dropdown-item text-sm py-2 px-4 gap-4 font-normal w-full flex items-center whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex flex-col gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "font-bold",
                                                                    children: userProfile.fullName
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "bg-primary text-white rounded-[20px] py-1 px-2 cursor-pointer",
                                                                    onClick: function() {
                                                                        router.push("/profile");
                                                                    },
                                                                    children: "View profile"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                    className: "w-[90%] mx-auto my-2 border-yellow"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "/profile/chats",
                                                        children: "Chats"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "/profile/offers",
                                                        children: "Offers"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "/profile/notifications",
                                                        children: "Notifications"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "#",
                                                        children: "Auction"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "/profile/settings",
                                                        children: "Settings"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                    className: "w-[90%] mx-auto my-2 border-yellow"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 cursor-pointer ",
                                                        onClick: next_auth_react__WEBPACK_IMPORTED_MODULE_5__.signOut,
                                                        children: "Log Out"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function HelpButton(param) {
    var hide = param.hide, setHide = param.setHide;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "dropdown relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: " dropdown-toggle px-2 py-2.5 transition duration-150 ease-in-out flex relative items-center whitespace-nowrap ",
                type: "button",
                id: "dropdownMenuButton1",
                onClick: function() {
                    setHide(!hide);
                },
                children: [
                    "Help",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        "aria-hidden": "true",
                        focusable: "false",
                        "data-prefix": "fas",
                        "data-icon": "caret-down",
                        className: "w-2 ml-2",
                        role: "img",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "currentColor",
                            d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "\n          dropdown-menu\n          absolute\n          min-w-max\n          block\n          bg-white\n          text-base\n          ".concat(hide == true ? "hidden" : "block", "\n          z-50\n          float-left\n          py-2\n          list-none\n          text-left\n          rounded-lg\n          shadow-lg\n          mt-1\n          m-0\n          bg-clip-padding\n          border-none\n        "),
                "aria-labelledby": "dropdownMenuButton1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                            href: "#",
                            children: "Contact Us"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: " dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100 ",
                            href: "#",
                            children: "FAQ's"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9603);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);





function Home(param) {
    var anyActive = param.anyActive;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-between items-center gap-6 px-6 h-[60px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "p-2 rounded-md bg-primary justify-center align-middles text-white shadow-md lg:hidden xl:hidden my-2",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: "Categories"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full block flex-grow lg:flex lg:items-center lg:w-auto ".concat(isOpen ? "block" : "hidden"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col justify-start align-left align-center text-start lg:flex-row xl:flex-row bg-primary fixed z-50 right-0 top-0 lg:relative xl:relative w-[100%] gap-4 lg:bg-transparent xl:bg-transparent px-4 py-4 md:py-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between items-center py-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-bold text-lg text-white block md:hidden",
                                    children: "Categories"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "border flex h-[40px] w-[40px] md:hidden justify-center items-center border-yellow text-white rounded-md cursor-pointer",
                                    onClick: function() {
                                        setIsOpen(false);
                                    },
                                    children: "X"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ".concat(router.asPath == "/" || router.asPath == "/profile" || router.asPath == "/profile/addproduct" ? "text-white" : router.asPath.split("/")[2] == "books" ? "text-white" : "text-white", " "),
                            onClick: function() {
                                router.push("/category/books");
                            },
                            children: "Books"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ".concat(router.asPath == "/" || router.asPath == "/profile" || router.asPath == "/profile/addproduct" ? "text-white" : router.asPath.split("/")[2] == "computer_and_accessories" ? "text-white" : "text-white"),
                            onClick: function() {
                                router.push("/category/computer_and_accessories");
                            },
                            children: "Computer and accessories"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ".concat(router.asPath == "/" || router.asPath == "/profile" || router.asPath == "/profile/addproduct" ? "text-white" : router.asPath.split("/")[2] == "clothes_and_accessories" ? "text-white" : "text-white"),
                            onClick: function() {
                                router.push("/category/clothes_and_accessories");
                            },
                            children: "Cloths and accessories"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ".concat(router.asPath == "/" || router.asPath == "/profile" || router.asPath == "/profile/addproduct" ? "text-white" : router.asPath.split("/")[2] == "luggage_and_bags" ? "text-white" : "text-white"),
                            onClick: function() {
                                router.push("/category/luggage_and_bags");
                            },
                            children: "Luggage and bags"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ".concat(router.asPath == "/" || router.asPath == "/profile" || router.asPath == "/profile/addproduct" ? "text-white" : router.asPath.split("/")[2] == "furnitures" ? "text-white" : "text-white"),
                            onClick: function() {
                                router.push("/category/furnitures");
                            },
                            children: "Furnitures"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ".concat(router.asPath == "/" || router.asPath == "/profile" || router.asPath == "/profile/addproduct" ? "text-white" : router.asPath.split("/")[2] == "phones_and_accessories" ? "text-white" : "text-white"),
                            onClick: function() {
                                router.push("/category/phones_and_accessories");
                            },
                            children: "Phones and accessories"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 2807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ toCloudinary; },
/* harmony export */   "v": function() { return /* binding */ toBackend; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5121);

var cloudinaryName = "dae4sosbl";
var baseURL = "https://bartcash.onrender.com/v1/";
var toBackend = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: baseURL
});
var toCloudinary = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.cloudinary.com/v1_1/".concat(cloudinaryName, "/image/"),
    headers: {
        "Content-Type": "multipart/form-data"
    }
});


/***/ })

}]);